<div class="tree-node-host">
  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <!--<mat-tree-node class="override-mat-tree-node" *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding matTreeNodePaddingIndent="5">
      
      <mat-checkbox class="override-mat-checkbox" [checked]="nodeIsSelected(node)"
                    (change)="toggleSelection(node)">
        {{node.item}}
      </mat-checkbox>
    </mat-tree-node>-->
    <mat-tree-node class="override-mat-tree-node" *matTreeNodeDef="let node" matTreeNodePadding matTreeNodePaddingIndent="15">
      <button *ngIf="doesHaveChild(node)" class="override-button" mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.item">
        <span class="fas" [ngClass]="{
          'fa-angle-right': !treeControl.isExpanded(node),
          'fa-angle-down': treeControl.isExpanded(node)
          }"></span>
      </button>
      <div *ngIf="!doesHaveChild(node)" class="override-button"></div>
      <mat-checkbox class="override-mat-checkbox" (click)="$event.stopPropagation()"
                    [checked]="nodeIsSelected(node)"
                    [indeterminate]="descendantsPartiallySelected(node)"
                    (change)="toggleSelection(node)">
        {{node.item}}
      </mat-checkbox>
    </mat-tree-node>
  </mat-tree>
</div>
